// DigitalOcean Spaces origin URL'lerini CDN (edge) URL'ine çevirir.
//
// Origin : https://araclo-bucket.sfo3.digitaloceanspaces.com/recipe_app/foo.jpg
// CDN    : https://araclo-bucket.sfo3.cdn.digitaloceanspaces.com/recipe_app/foo.jpg
//
// Tek fark bölge kodundan sonra gelen "cdn." parçasıdır.
const SPACES_HOST = /^([a-z0-9-]+\.[a-z0-9-]+)\.digitaloceanspaces\.com$/i;

export const toCdnUrl = (url) => {
  if (!url || typeof url !== 'string') return url;

  try {
    const parsed = new URL(url);
    const match = parsed.hostname.match(SPACES_HOST);

    // Spaces origin değilse (veya zaten cdn.* ise) olduğu gibi bırak
    if (!match) return url;

    parsed.hostname = `${match[1]}.cdn.digitaloceanspaces.com`;
    return parsed.toString();
  } catch {
    // Göreli path veya geçersiz URL — dokunma
    return url;
  }
};

export default toCdnUrl;
